import React from 'react';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-[#2c3e50] text-white py-3 text-center">
      <p>&copy; {currentYear} Vixen Hollow. All rights reserved.</p>
    </footer>
  );
};

export default Footer; 